import APIServices from "../APIServices.js";

/***************************************** ENDPOINTS *****************************************/
const API_GET_ON_STATION = "/verizon/picaCSVz/getAllOnStation";
const API_GET_STATS = "/verizon/picaCSVz/getStats";
const API_POST_SEARCH = "/verizon/picaCSVz/search";

/***************************************** METHODS *****************************************/
export function getOnStation() {
  return APIServices.get(API_GET_ON_STATION);
}

export function getStats(startDate, endDate) {
  const reqURL = `${API_GET_STATS}?startDate=${startDate}&endDate=${endDate}`;
  return APIServices.get(reqURL);
}

export function search(payload, page, limit, callback) {
  let reqURL = `${API_POST_SEARCH}?page=${page}&limit=${limit}`;
  APIServices.post(reqURL, payload).then((res) => {
    callback(res);
  });
}



// WEBPACK FOOTER //
// ./src/services/clients/api_pica_cs_vz.js